import React from "react";
import { Link } from "react-router-dom";
import useDocumentTitle from "../useDocumentTitle";

export default function DirectionBNotFound() {
  useDocumentTitle("Page not found | Brant Levinson");
  return <div className="direction-b-site direction-b-not-found"><main><div className="direction-b-detail__inner"><span className="direction-b-eyebrow"><span />404</span><h1>That page is not part of the system.</h1><p>The requested path does not resolve to a published profile or case study.</p><Link className="direction-b-button direction-b-button--primary" to="/">Back to home</Link></div></main></div>;
}
